

export class HomePageContext {

    public routeTo: string[] = [];
    public firstName: string = "Pramod";
    public lastName: string = "Variya";

    constructor(routeTo: string[]) {
        this.routeTo = routeTo
    }
}